import { useBadgeData } from './useBadgeCounts';

export const requestsQueryKey = (type) => [`${type}-requests`];
export const requestsCountQueryKey = (type) => [`${type}-requests`, 'count'];

/** Pending count of a single-candidate request type ('passport' | 'accommodation'), for the sidebar badge. */
export function useCandidateRequestCount(type) {
  return useBadgeData().data?.[`${type}_requests`] ?? 0;
}
